export default `
  subscription onCreateChatLog($workflowId: ID!) {
    onCreateChatLog(workflowId: $workflowId) {
      id
      workflowId
      type
      content
      userId
      aiOutput
      workflowVersion
      createdAt
    }
  }
`
